<template>
    <router-view :taxonomy="taxonomy" :termId="termId" :categoryName="categoryName"></router-view>
</template>

<script>
    export default {
        name: 'app',
        props: {
            categoryName: {
                type: String,
                required: true
            },
            taxonomy: {
                type: String,
                required: true
            },
            termId: {
                type: Number,
                required: true
            }
        },
    }
</script>



// WEBPACK FOOTER //
// app.vue?ef21062e